export default __webpack_public_path__ + "static/media/gaspol.2420653b.png";